import script from "./PaperWaitSteps.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperWaitSteps.vue?vue&type=script&setup=true&lang=js"

import "./PaperWaitSteps.vue?vue&type=style&index=0&id=7786f40c&lang=css"

const __exports__ = script;

export default __exports__